var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyValuesHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8069 30.5304C17.8246 30.5005 17.8427 30.4709 17.8613 30.4413C19.2158 28.2881 19.9999 25.7418 19.9999 23C19.9999 20.7909 21.7908 19 23.9999 19C26.209 19 27.9999 20.7909 27.9999 23C27.9999 24.017 27.9307 25.0186 27.7966 26M25.6792 32.8436C26.2909 31.6226 26.7924 30.3369 27.1707 29M31.0097 30.132C31.6547 27.8657 32 25.4732 32 23C32 18.5817 28.4183 15 24 15C22.5429 15 21.1767 15.3896 20 16.0703M15 27.3641C15.6407 26.0454 16 24.5646 16 23C16 21.5429 16.3896 20.1767 17.0703 19M23.9999 23C23.9999 26.5172 22.9911 29.7988 21.2471 32.5712",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyValuesHover);
export default __webpack_public_path__ + "static/media/company-values-hover.39d98e00a60e2df8f863c833c74d79ea.svg";
export { ForwardRef as ReactComponent };